// loader-interceptor.service.ts
import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SpinnerService } from "../shared/spinner/spinner.service";
import { tap } from 'rxjs/operators';
import { PreCheckoutService } from '../services/pre-checkout.service';
import { Auth } from '../models/auth.model';
import { CircuitBreakerService } from '../services/circuit-breaker.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: SpinnerService,
    private preCheckoutService: PreCheckoutService,
    private circuitBreakerService: CircuitBreakerService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.requestStarted();
    return this.handler(next, req);
  }
  handler(next: HttpHandler, req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return next.handle(req)
    .pipe(
      tap(
        (event) => {
          if(event instanceof HttpResponse)
          {
            this.loaderService.requestEnded();
          }
        },
        (error: HttpErrorResponse) => {
          if(error.status==401)
            if(this.circuitBreakerService.circuitStart(error.url, error.status))
              this.getAccessToken();
            
          this.loaderService.resetSpinner();
          throw error;
        }
      )
    )
  }

  getAccessToken(){
    this.preCheckoutService.Authentication()
    .subscribe(
      (result) => {
        new Auth(
                result.user_id, 
                result.authenticated, 
                result.access_token, 
                result.created, 
                result.expiration
        )
      },
      (err) => {
        console.log("[LOADER-INTERCEPTOR] - Ocorreu um erro ao tentar recuperar token de acesso, tente novamente!");
      }
    );
  }
}